import { ENDPOINTS } from "config/endpoints";
import { useMutation, useQueryClient } from "react-query";
import Error from "types/error";
import client from "utils/clients/client";
import { Request } from "types/request";
import { Response } from "types/response";
import StripeEnvironment from "types/enums/stripeEnvironment";

export interface PatchPaymentCustomerInputs {
  subscriptionId: number;
  userId: number;
  stripeCustomerId: string;
  stripeEnvironment: StripeEnvironment;
}

export default function usePatchPaymentCustomer() {
  const queryClient = useQueryClient();

  const patchPaymentCustomer = (inputs: PatchPaymentCustomerInputs) => {
    const request: Request = {
      url: `${ENDPOINTS.subscription.paymentCustomer}`,
      config: {
        method: "patch",
        data: { data: inputs },
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<null>,
    Error,
    PatchPaymentCustomerInputs
  >(patchPaymentCustomer, {
    onSettled: () => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey.toString().startsWith(ENDPOINTS.subscription.main),
      });
    },
  });

  return { data, mutate, ...rest };
}
